import { render, staticRenderFns } from "./GameClient.vue?vue&type=template&id=7a2ef843&"
import script from "./GameClient.vue?vue&type=script&lang=js&"
export * from "./GameClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports